import { useGetFilterAPI } from '@legacy/apis/filterAPI';
import { FilterLayout } from '@legacy/components/layout/FilterLayout';
import { ResponseHandler } from '@legacy/components/utils/ResponseHandler';
import { useGetCurrentPageIdentifier } from '@legacy/stores/PageStore/pageStore.zustand';
import { TimeRegistrationsTable } from './Table';

const Report = () => {
  const pageIdentifier = useGetCurrentPageIdentifier();
  const { filterList, isError, isLoading } = useGetFilterAPI(pageIdentifier);

  return (
    <ResponseHandler
      isLoading={isLoading}
      isEmpty={filterList.length <= 0}
      isError={isError}
    >
      <FilterLayout localStorageNamePrefix="report" filterList={filterList}>
        <TimeRegistrationsTable />
      </FilterLayout>
    </ResponseHandler>
  );
};

export default Report;
